import type { Score } from "./types";

/**
 * Vulnerability is rated per asset, per hazard, from two components
 * (functional spec §2.2):
 *  - businessImpact: client-rated importance of the asset's function (Tab 1)
 *  - assetPhysicalImpact: 180Pi default physical vulnerability for the
 *    asset's mapped value chain stage
 *
 * Combination rule: take the higher of the two; if they're equal and that
 * value is 2 or 3, bump up one level. (Verified against the spec's full 4x4
 * table in the test suite — this rule reproduces it exactly.)
 */
export function combineVulnerability(
  businessImpact: Score,
  assetPhysicalImpact: Score,
): Score {
  const higher = Math.max(businessImpact, assetPhysicalImpact) as Score;

  if (businessImpact === assetPhysicalImpact && (higher === 2 || higher === 3)) {
    return (higher + 1) as Score;
  }

  return higher;
}
